// extracted by mini-css-extract-plugin
module.exports = {"icons":"PriceIcons_icons__1ibEv","icon":"PriceIcons_icon__1rFvQ","selected":"PriceIcons_selected__1JS0Y","price-quote-container":"PriceIcons_price-quote-container__1YXhm"};